
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import UpdateBankInfo from './updateBankInfo';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class ViewUpdateBankInfo extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'User Status',
                content: <UpdateBankInfo />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ViewUpdateBankInfo
